/*
 *  Copyright (C) UMISIS SOLUTIONS SRL - All Rights Reserved
 *  * Unauthorized copying of this file, via any medium is strictly prohibited
 *  * Proprietary and confidential
 *  * Written by Emanuel Gug <manu144x@gmail.com>, September 2018
 *
 */

import { useItemsStore } from '@/stores/items.js'

export default {
  computed: {
    itemsStoreModule() {
      return useItemsStore()
    },
    page: {
      get() {
        return this.itemsStoreModule.page
      },
      set(newVal) {
        this.itemsStoreModule.page = newVal
      }
    },
    perPage() {
      return this.itemsStoreModule.perPage
    },
    lastPage() {
      return this.itemsStoreModule.lastPage
    },
    total() {
      return this.itemsStoreModule.total
    },
    showPaginator() {
      return this.total > this.perPage
    },
    orderBy() {
      return this.itemsStoreModule.orderBy
    },
    orderDirection() {
      return this.itemsStoreModule.orderDirection
    },
    paginationParamsObject() {
      return {
        page: this.page,
        per_page: this.perPage,
        order_by: this.orderBy,
        order_direction: this.orderDirection
      }
    },
    sortMethodsOptions() {
      return [
        { id: 'desc', name: 'Descending' },
        { id: 'asc', name: 'Ascending' },
      ]
    }
  }
}
